import { Component, inject, OnInit } from '@angular/core';
import { MercadoPagoService } from '../../services/mercado-pago.service';
import { OtpService } from '../../services/otp.service';
import { Client, MercadoPagoSettings } from '../../interfaces/interfaces';
import { LocaleService } from '../../services/locale.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-process-checkout',
  standalone: true,
  imports: [],
  templateUrl: './process-checkout.component.html',
  styleUrl: './process-checkout.component.css'
})
export class ProcessCheckoutComponent implements OnInit {
  client!: Client;
  mercadoPagoSettings!: MercadoPagoSettings;
  mp: any;
  localeService = inject(LocaleService);
  mercadoPagoService = inject(MercadoPagoService);
  private otpService = inject(OtpService);
  
  ngOnInit(): void {
    this.client = this.otpService.loadCachedClient();
    this.setMercadoPagoSettings();
    this.localeService.setCountryCurrency(this.client.country);
    this.localeService.setCheckout(this.client.country, this.client.paymentAmount, this.client.description);
    this.mercadoPagoService.launchMercadoPago();
  }

  setMercadoPagoSettings() {
    this.mercadoPagoService.setInitializationAmount(this.client.country);
    this.mercadoPagoService.setIsPayment(this.client.realPayment);
    this.mercadoPagoService.setMercadopagoToken(this.client.country);
    console.log(this.mercadoPagoService.getSettings());
  }
}
